import React, { Component } from "react";
import PropTypes from "prop-types";
import { findDOMNode } from "react-dom";
import ItemTypes from "./ItemTypes";
import { DragSource, DropTarget } from "react-dnd";
import flow from "lodash/flow";
import StepForm from "./StepForm";
import { CSSTransitionGroup } from 'react-transition-group';

const style = {
  border: "1px solid #DDDDDD",
  cursor: "move"
};

const stepSource = {
  beginDrag(props) {
    return {
      id: props.id,
      index: props.index
    };
  },
  canDrag(props) {
    return props.stepEnabled;
  }
};

const stepTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Determine rectangle on screen
    const hoverBoundingRect = component.targetEl.getBoundingClientRect();

    // Get vertical middle
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

    // Determine mouse position
    const clientOffset = monitor.getClientOffset();

    // Get pixels to the top
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%

    // Dragging downwards
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return;
    }

    // Dragging upwards
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return;
    }

    // Time to actually perform the action
    props.moveStep(dragIndex, hoverIndex);

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
  }
};

class Step extends Component {
  static propTypes = {
    moveStep: PropTypes.func.isRequired,
    handleSave: PropTypes.func.isRequired,
    handleFetch: PropTypes.func.isRequired,
    handleRemove: PropTypes.func.isRequired,
    handleTooltipForPause: PropTypes.func.isRequired,
    connectDragSource: PropTypes.func.isRequired,
    connectDropTarget: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    isDragging: PropTypes.bool.isRequired,
    isNew: PropTypes.bool,
    match: PropTypes.object.isRequired,
    id: PropTypes.number,
    delayValue: PropTypes.string,
    delayUnit: PropTypes.string,
    templates: PropTypes.array,
    smsTemplates: PropTypes.array,
    rvmTemplates: PropTypes.array,
    postcard_templates: PropTypes.array,
    emailTemplateId: PropTypes.number,
    smsTemplateId: PropTypes.number,
    rvmTemplateId: PropTypes.number,
    postcardTemplateId: PropTypes.number,
    medium: PropTypes.string,
    medium_data: PropTypes.object,
    senders: PropTypes.array,
    rookeryEnabled: PropTypes.boolean,
    stepEnabled: PropTypes.boolean
  };

  getInitialState() {
    return { isDeleting: false };
  }

  removeStep(e) {
    let key = e.target.dataset.key;
    this.setState({ isDeleting: true });
    setTimeout(() => {
      this.props.handleRemove(key);
    }, 500);
  }

  render() {
    const {
      id,
      index,
      delayValue,
      delayUnit,
      medium,
      medium_data,
      senders,
      rookeryEnabled,
      emailTemplateId,
      smsTemplateId,
      rvmTemplateId,
      postcardTemplateId,
      templates,
      smsTemplates,
      rvmTemplates,
      postcard_templates,
      isDragging,
      connectDragSource,
      connectDropTarget
    } = this.props;
    const opacity = isDragging ? 0 : 1;
    const klass = this.props.stepEnabled ? " hide" : "";
    const isNewKlass = this.props.isNew ? " isNew" : "";
    const isDeleting =
      this.state && this.state.isDeleting
        ? " example-leave example-leave-active"
        : "";
    return connectDragSource(
      connectDropTarget(
        <div
          ref={el => this.targetEl = el}
          className={"row step" + isNewKlass + isDeleting}
          style={{ ...style }}
        >
          <CSSTransitionGroup
            transitionName="example"
            transitionAppear={true}
            transitionAppearTimeout={500}
            transitionLeave={true}
            transitionLeaveTimeout={300}
          >
            <div className={"step_disabled" + klass} />
            <div className="col-sm-11">
              <StepForm
                key={id}
                id={id}
                formKey={index.toString()}
                handleSave={this.props.handleSave}
                handleFetch={this.props.handleFetch}
                handleTooltipForPause={this.props.handleTooltipForPause}
                delayValue={delayValue}
                delayUnit={delayUnit}
                medium={medium}
                medium_data={medium_data}
                senders={senders}
                rookeryEnabled={rookeryEnabled}
                emailTemplateId={emailTemplateId}
                smsTemplateId={smsTemplateId}
                rvmTemplateId={rvmTemplateId}
                postcardTemplateId={postcardTemplateId}
                templates={templates}
                smsTemplates={smsTemplates}
                rvmTemplates={rvmTemplates}
                postcard_templates={postcard_templates}
                match={this.props.match}
                stepEnabled={this.props.stepEnabled}
              />
            </div>
            <div className="col-sm-1">
              <button
                data-key={index}
                className="btn btn-sm btn-danger pull-right remove_step_btn"
                onClick={this.removeStep.bind(this)}
              >
                <i className="fa fa-close fa-1x" />
              </button>
            </div>
          </CSSTransitionGroup>
        </div>
      )
    );
  }
}

export default flow(
  DragSource(ItemTypes.STEP, stepSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  })),
  DropTarget(ItemTypes.STEP, stepTarget, connect => ({
    connectDropTarget: connect.dropTarget()
  }))
)(Step);
